import React, { useMemo, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { useUser } from './../../../commons/customHooks/Account'
import { useRegisterAwardEntry } from './../../../commons/customHooks/Award'
import {
  useAward,
  useAwardEntry,
  useMyAwardEntry,
  useSubmitAwardVote,
  checkVoted,
} from "./../../../commons/customHooks/Award"

import HeaderHs2 from '../../../commons/components/Header/headerHs2';
import MainLayout from '../../../commons/layout/MainLayout';

import VoteInfo from '../components/Vote/VoteInfo';
import VoteSearch from '../components/Vote/VoteSearch';
import VoteFilter from '../components/Vote/VoteFilter';
import VoteList from '../components/Vote/VoteList';

import ROUTERS from "../../../commons/constans/router";
import { priceFormat } from '../../../utils/helpers'
import BacktoTopComponent from "../../../commons/components/BackToTop";

const FILTERS = [
  {value: 1, orderBy: 'total_vote', sortedBy: 'DESC', title: '순위 순'},
  {value: 2, orderBy: 'created_at', sortedBy: 'DESC', title: '최신 순'},
  {value: 3, orderBy: 'name', sortedBy: 'ASC', title: '가나다 순'},
]

const DEFAULT_LIMIT = 10
const LOADMORE_LIMIT = 30
const LIMIT_ENTRY_EACH_VOTE = 2

function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

const AwardRegisterContainer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = useQuery();
  const { user } = useUser();
  const [ myEntryParams, setMyEntryParam ] = useState({
    orderBy: FILTERS[0].orderBy,
    sortedBy: FILTERS[0].sortedBy,
  })
  const [ myEntry ] = useMyAwardEntry(myEntryParams);
  const [ voted ] = checkVoted();
  const [ entryParams, setEntryParams ] = useState({
    page: 1,
    limit: DEFAULT_LIMIT,
    orderBy: FILTERS[0].orderBy,
    sortedBy: FILTERS[0].sortedBy,
    skip: 0,
    id: null,
    search_text: '',
  })
  const [ entries, loading, entries_params ] = useAwardEntry(entryParams);
  const [ filter, setFilter ] = useState(FILTERS[0]);
  const [ loadingChangeTab, setLoadingChangeTab ] = useState(false);
  const award_params = useMemo(() => ({limit: DEFAULT_LIMIT, type: "top"}), [filter])
  const [ award ] = useAward(award_params);

  const [ selectedEntries, setSelectedEntries ] = useState([]);

  const [loadingSubmit, handleSubmit, voteSuccess] = useSubmitAwardVote();
  const [back, setback] = useState(-1);
  const [isShowTooltip, setIsShowTooltip] = useState(false);

  const handleLeftClick = () => {
    navigate(back);
  }

  useEffect(() => {
    if (voteSuccess) {
      navigate(ROUTERS.AWARD);
    }
  }, [voteSuccess])

  useEffect(() => {
    if (voted && voted.length) {
      let a = voted.map((v) => v.award_entry)
      setSelectedEntries(a)
    }
  }, [voted, entries.length])

  useEffect(() => {
    setSelectedEntries([])
  }, [user.id])

  useEffect(() => {
    setEntryParams(p => ({
      ...p,
      page: 1,
      skip: 0,
      orderBy: filter.orderBy,
      sortedBy: filter.sortedBy,
      // id: null,
      limit: DEFAULT_LIMIT,
    }))
    setMyEntryParam(p => ({
      ...p,
      orderBy: filter.orderBy,
      sortedBy: filter.sortedBy,
    }))
    setLoadingChangeTab(true)
  }, [filter.orderBy, filter.sortedBy])

  useEffect(() => {
    if (query.get('id')) {
      // setEntryParams(p => ({
      //   ...p,
      //   page: 1,
      //   skip: 0,
      //   id: query.get('id'),
      // }))
      setback(ROUTERS.AWARD)
      navigate(location.pathname, { replace: true });
    }
  }, [query.get('id')])

  useEffect(() => {
    if (!loading) {
      setLoadingChangeTab(false)
    }
  }, [loading])

  useEffect(() => {
    scrollTo(0, 0)
  }, [])

  const loadMore = () => {
    setEntryParams(p => ({
      ...p,
      page: (p.limit === DEFAULT_LIMIT) ? 1 : p.page + 1,
      limit: LOADMORE_LIMIT,
      skip: DEFAULT_LIMIT,
    }))
  }

  const onSelectEntry = (item) => {
    if (voted) return;
    let clone = selectedEntries.find(e => e.id === item.id)
    if (!clone) {
      if (selectedEntries.length < LIMIT_ENTRY_EACH_VOTE) {
        setSelectedEntries(p => ([...p, item]))
      }
    } else {
      clone = [...selectedEntries].filter(e => e.id !== item.id)
      setSelectedEntries(clone)
    }
  }

  useEffect(() => {
    if (selectedEntries && selectedEntries.length == 1) {
      setIsShowTooltip(true)
      window.scrollTo({
        top: document.body.scrollHeight,
        left: 0,
        behavior: 'smooth'
      });
      const timer = setTimeout(() => {
        setIsShowTooltip(false);
        clearTimeout();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [selectedEntries])

  const _handleSubmit = e => {
    e.preventDefault()
    let data = {
      ids: selectedEntries.map(e => e.id)
    }
    handleSubmit(data)
  }

  const onSearchSelectItem = (item = null) => {
    setEntryParams(p => ({
      ...p,
      page: 1,
      skip: 0,
      id: item?.id,
    }))
  }

  const onChangeSearchText = (search_text) => {
    setEntryParams(p => ({
      ...p,
      page: 1,
      skip: 0,
      search_text,
    }))
  }
  

  return (
    <>
      <MainLayout
        pageID={'voting-page'}
        displayBottomNav={false}
        activeNav={''}
      >
        <HeaderHs2
          labelRight={false}
          labelLeft={true}
          title="투표하기"
          handleLabelLeft={() => handleLeftClick()}
        />
        <div className="wrapper">
          <div className="main-voting-page">
            {award.id && <VoteInfo award={award} />}
            <div className="search-voting">
              <div className="search-voting-content" id='js-voting-list'>
                <VoteSearch
                  onSelect={onSearchSelectItem}
                  onChange={onChangeSearchText}
                  // searchText={entryParams.id ? (entries[0]?.user?.nickname || '') : ''}
                />
                <VoteFilter
                  filters={FILTERS}
                  active={filter}
                  onSelectFilter={setFilter}
                />
                {/*{loading && loadingChangeTab && 'loading'}*/}

                {myEntry?.id && !myEntry?.deleted_at && <VoteList
                  entries={[myEntry]}
                  rank={myEntry.rank}
                  onSelect={onSelectEntry}
                  selected={selectedEntries}
                />}

                <VoteList
                  entries={entries}
                  onSelect={onSelectEntry}
                  selected={selectedEntries}
                />
                {entries_params.next_page_url ? (
                  <button
                    className="btn btn-action active-minus"
                    type="button"
                    onClick={loadMore}
                  >
                    <label className="btn-action__icon">+</label>
                    <label className="btn-action__text">
                      더보기{entryParams.page > 1 && loading ? '...' : ''}
                    </label>
                  </button>
                ) : (
                  null
                )}
                {(!voted && selectedEntries.length) ?
                  <div
                    className={`btn-clear`}
                  >
                    <span onClick={() => setSelectedEntries([])}>전체선택해제</span>
                  </div>
                : null
                }
                <div className={`search-voting__submit${(!voted && selectedEntries.length) ? ' mt-0' : ''}`}>
                
                  {
                    selectedEntries.length == 1 && isShowTooltip ? 
                    <div className='tooltip-box'>
                        <div className='arrow-down'></div>
                        <img src="/images/list_tooltip.svg" alt="" />
                        <span>한 명의 아이에게 더 투표해주세요!</span>
                    </div>
                    : ''
                  }
                  <button
                    type="button"
                    className={`btn btn-block btn-primary award-signup-form__submit mt-0` }
                    disabled={voted || selectedEntries.length < LIMIT_ENTRY_EACH_VOTE}
                    onClick={_handleSubmit}
                  >
                    {voted ? '투표완료' : '투표하기'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <BacktoTopComponent />
      </MainLayout>
    </>
  );
};

export default AwardRegisterContainer;
